import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import TestimonialModeration from "@/pages/admin/TestimonialModeration";
export const Route = createFileRoute("/admin/testimonials")({ component: () => <RouteGuard access={{ kind: "admin" }}><TestimonialModeration /></RouteGuard> });
